export const SCHEDULE_WINDOW_IN_HOURS = 4;
export const SCHEDULE_WINDOW_IN_MINUTES = SCHEDULE_WINDOW_IN_HOURS * 60;
